"use strict";

export default class SettingsController {
  user = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };
  errors = {
    other: undefined,
  };
  message = "";
  submitted = false;

  /*@ngInject*/
  constructor(Auth, gettextCatalog, LanguageService, Modal) {
    this.Auth = Auth;
    this.gettextCatalog = gettextCatalog;
    this.ls = LanguageService;
    this.Modal = Modal;
  }

  changePassword(form) {
    this.submitted = true;
    var that = this;
    if (form.$valid) {
      this.Auth.changePassword(this.user.oldPassword, this.user.newPassword)
        .then(() => {
          this.Modal.confirm.info(() => {})(
            this.gettextCatalog.getString("Mot de passe"),
            this.gettextCatalog.getString(
              "Votre mot de passe a bien été modifié."
            ),
            "OK",
            "primary"
          );
        })
        .catch((err) => {
          //form.password.$setValidity('mongoose', false);

          err = err.data;
          this.errors = {};
          // Update validity of form fields that match the sequelize errors
          if (err.name == "dal-error") {
            for (var fname in err.fields) {
              if (err.fields.hasOwnProperty(fname)) {
                form[fname].$setValidity("mongoose", false);
                this.errors[fname] = this.ls.lang == "fr" ? err.fr : err.en;
              }
            }
          } else {
            for (var fname in err.fields) {
              if (err.fields.hasOwnProperty(fname)) {
                form[fname].$setValidity("mongoose", false);
                this.errors[fname] = err.message;
              }
            }
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/settings/settings.controller.js